function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M27.2 3.9H2.8C1.4 3.9.2 5.1.2 6.5v16.9c0 1.4 1.2 2.6 2.6 2.6h24.4c1.4 0 2.6-1.2 2.6-2.6V6.6c0-1.5-1.2-2.7-2.6-2.7zM2.8 5.4h24.4c.6 0 1.1.5 1.1 1.1v2.8c-.1 0-.2-.1-.2-.1H1.9c-.1 0-.2 0-.2.1V6.6c0-.7.5-1.2 1.1-1.2zm24.4 19.2H2.8c-.6 0-1.1-.5-1.1-1.1V11.3c.1 0 .2.1.2.1H28c.1 0 .2 0 .2-.1v12.2c.1.6-.4 1.1-1 1.1zm-9.6-8.7c0 .4-.3.8-.8.8H6.6c-.4 0-.8-.3-.8-.8s.3-.8.8-.8h10.3c.4.1.7.4.7.8zm-3.7 3.8c0 .4-.3.8-.8.8H6.6c-.4 0-.8-.3-.8-.8s.3-.8.8-.8h6.6c.3 0 .7.4.7.8z",
  fill: "currentColor"
})));